<script>
import CTA from '../common/CTA';
import MixedGridImageItem from '@maison/components/mixedGrid/MixedGridImageItem';
import MixedGridVideoItem from '@maison/components/mixedGrid/MixedGridVideoItem';

export default {
  components: {
    CTA,
    MixedGridImageItem,
    MixedGridVideoItem,
  },

  inheritAttrs: false,

  props: {
    cta: {
      type: Object,
      required: true,
    },
    image: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      required: true,
    },
    video: {
      type: Object,
      default: () => ({}),
    },
    size: {
      type: Number,
      required: true,
    },
    itemId: {
      type: String,
      default: '',
    },
  },

  computed: {
    hasVideo() {
      return Object.keys(this.video).length !== 0;
    },
  },
};
</script>

<template>
  <div class="card card--sm" data-cy="mixed-grid-item">
    <mixed-grid-video-item v-if="hasVideo" :item-id="itemId" :size="size" v-bind="video" />
    <mixed-grid-image-item v-else :image="image" :is-sub-component="true" />

    <div class="card-body">
      <h2 class="h4">{{ title }}</h2>

      <ul class="list list--mixed card-body__buttons max-sm:list--full">
        <li role="presentation">
          <c-t-a v-bind="cta" expand-target />
        </li>
      </ul>
    </div>
  </div>
</template>
